import React from "react";
import TweenOne from 'rc-tween-one';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import logoS from '../img/logoS.png';
import '../../CSS/style.css';

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: '首页',
            tabList: [],
        }
    }
    componentWillMount() {
        this.getTabList();
        setInterval(() => {
            //获取浏览器路径
            const hrefList = window.location.href.split('/');
            let activeTab = hrefList[hrefList.length - 1];
            activeTab = '/' + activeTab;
            const { tabList } = this.state;
            const activeItem = tabList.filter(item => item.url === activeTab);
            const activeTabName = activeItem[0].name;
            sessionStorage.setItem('activeTab', activeTabName);
            //获取sessionStorage的值，设置到activeTab中
            if(sessionStorage.getItem('activeTab')){
                const {activeTab} = this.state;
                const newActiveTab = sessionStorage.getItem('activeTab');
                if (newActiveTab !== activeTab) {
                    this.setState({activeTab: newActiveTab})
                }
            }
        }, 100);
    }

    getTabList = () => {
        const tabList = [{
            name: '首页',
            url: '/'
        }, {
            name: '产品服务',
            url: '/product'
        }, {
            name: '行业应用',
            url: '/industrySolutions'
        }, {
            name: '客户案例',
            url: '/customerCase'
        }, {
            name: '关于我们',
            url: '/contactUs'
        }];
        this.setState({
            activeTab: '首页',
            tabList
        })
    };
    selectTab = (activeTab) => {
        this.setState({ activeTab });
        sessionStorage.setItem("activeTab",activeTab)
    };

    render() {
        const { scrollTop } = this.props;
        const { tabList, activeTab } = this.state;
        const tabListHtml = tabList.map((item, index) => (
            <Link to={item.url} style={{ margin: '20px 20px 0 20px' }} key={index}>
                <Row style={{ fontSize: 18 }} className={item.name === activeTab ? 'header-link-active' : 'header-link'} onClick={() => this.selectTab(item.name)}>{item.name}</Row>
            </Link>
        ));
        return (
            <Row type="flex"
                 justify="center"
                 style={{
                     top:0,
                     position:'fixed',
                     width:'100%',
                     minWidth: 1240,
                     backgroundColor:"#fff",
                     zIndex:9999,
                     height:72,
                     boxShadow: scrollTop > 0 ?'0 4px 8px -4px rgba(133,133,133,0.5)':"none",
                 }}>
                <Row type="flex" justify="space-between" align="middle" style={{ width: 1200 }}>
                    <Row style={{margin:'0 60px'}}>
                        <img src={logoS} alt="logo" width="170" />
                    </Row>
                    <Row type="flex" style={{margin:'0 40px'}}>
                        {tabListHtml}
                    </Row>
                </Row>
            </Row>
        )
    }
}